module.exports = __webpack_public_path__ + "static/img/3.e9c1963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/3.png
// module id = HggW
// module chunks = 1